import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useRouteStore } from '../../store/Route.store'

export const RouteTracker = () => {
  const location = useLocation()
  const pushRoute = useRouteStore(state => state.pushRoute)

  useEffect(() => {
    pushRoute(location.pathname)
  }, [location.pathname, pushRoute])

  return null
}
